import { useParams } from 'react-router';

export function useParamOrNull(param: string) {
    return useParams()[param] ?? null;
}
